import { Component, OnInit } from '@angular/core';
import { WipoAuthService } from 'src/app/_services/wipo-auth.service';

@Component({
  standalone: false,
  selector: 'app-home-page',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  public userAuthenticated = false;
  constructor(private wipoAuthService: WipoAuthService) {  }

  ngOnInit(): void {
  }

  login() {
    this.wipoAuthService.loginWithUserPassword();
  }

  scroll(el: HTMLElement) {
    el.scrollIntoView({behavior:"smooth"});
  }
}
